export default __webpack_public_path__ + "static/sc-grass-a9e084ac82ce89e57b4a9d3df9b0ca84.webp";